module.exports = __webpack_public_path__ + "img/header-engagementRingsSignature.671ce32.webp";